// extracted by mini-css-extract-plugin
export var shadowText = "shadows-module--shadowText--8YZZy";